import Cookies from 'universal-cookie';

export default function createUniversalCookie() {
    return new Cookies();
}